import { render, staticRenderFns } from "./symptom-report.vue?vue&type=template&id=1fa3e6cc&scoped=true&"
import script from "./symptom-report.vue?vue&type=script&lang=js&"
export * from "./symptom-report.vue?vue&type=script&lang=js&"
import style0 from "./symptom-report.vue?vue&type=style&index=0&id=1fa3e6cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa3e6cc",
  null
  
)

export default component.exports